/**
 * Bilet türü kataloğu (Story 19.2 — bulgu 10).
 *
 * Bilet türü SERBEST METİN DEĞİLDİR: raporlanabilir olsun diye tanımlı kümeden
 * seçilir. Etiketler `i18n` sözlüğündedir (`catalog.ticketKind.<tür>`, TR+EN);
 * bu dosya yalnızca kümeyi ve göç eşlemesini tutar.
 *
 * Faz 2'de fiyat alanı YOKTUR — `paid` türü satış akışı geldiğinde (Faz 4+)
 * anlam kazanır, şema şimdiden hazırdır.
 */
export const TICKET_KINDS = [
    'free',
    'paid',
    'invite',
    'student',
    'sponsor',
    'speaker',
    'press',
];
/** Göçte eşlenemeyen serbest metin buraya düşer (Faz 2'de fiyat yok → ücretsiz). */
export const TICKET_KIND_FALLBACK = 'free';
const TICKET_KIND_SET = new Set(TICKET_KINDS);
export function isTicketKind(value) {
    return typeof value === 'string' && TICKET_KIND_SET.has(value);
}
function normalize(value) {
    return value
        .replace(/İ/g, 'i')
        .replace(/I/g, 'i')
        .replace(/ı/g, 'i')
        .replace(/Ş|ş/g, 's')
        .replace(/Ğ|ğ/g, 'g')
        .replace(/Ü|ü/g, 'u')
        .replace(/Ö|ö/g, 'o')
        .replace(/Ç|ç/g, 'c')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
}
/**
 * Serbest metin → tür eşlemesi. Migration bu tabloyu KOPYALAR ve
 * `ticket-kind.spec.ts` iki listenin ayrışmadığını kanıtlar.
 */
export const TICKET_TYPE_NAME_TO_KIND = {
    ucretsiz: 'free',
    free: 'free',
    ucretli: 'paid',
    paid: 'paid',
    davetli: 'invite',
    davet: 'invite',
    invite: 'invite',
    ogrenci: 'student',
    student: 'student',
    sponsor: 'sponsor',
    konusmaci: 'speaker',
    speaker: 'speaker',
    basin: 'press',
    press: 'press',
};
/**
 * Eşlenemeyen değer KAYBOLMAZ: en yakın tür (`free`) döner, orijinal metin
 * `tickets.legacy_type_name` sütununda saklanır ve göç raporuna yazılır.
 */
export function resolveTicketKind(value) {
    if (!value)
        return TICKET_KIND_FALLBACK;
    if (isTicketKind(value))
        return value;
    return TICKET_TYPE_NAME_TO_KIND[normalize(value)] ?? TICKET_KIND_FALLBACK;
}
//# sourceMappingURL=ticket-kind.js.map